export default function Lightbox({ src, onClose }) {
  if (!src) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <img
        src={src}
        alt="Agrandissement"
        className="max-h-[85vh] max-w-[95vw] rounded-2xl border border-white/20 shadow-2xl"
      />
    </div>
  );
}
